import React from 'react';
import PropTypes from 'prop-types';
import { Sticky } from 'react-sticky';
import LoginModalHoc from 'core/hoc/LoginModalHoc';
import {
	StickyWrapper,
} from './navigationStyles';


/*
 * Higher Order Component that needs to be passed a component:
 * e.g. NavigationWithHoc(Navigation)
 */
const NavigationWithHoc = Navigation => {
	class NavigationContainer extends React.Component {
		render() {
			return (
				<LoginModalHoc contextUsage="navigation-login">
					{({ triggerLoginModal }) =>
						<StickyWrapper>
							<Sticky>
								{({ isSticky, style }) => (
									<Navigation
										style={style}
										isSticky={isSticky}
										triggerLoginModal={triggerLoginModal}
										{...this.props}
									/>
								)}
							</Sticky>
						</StickyWrapper>
					}
				</LoginModalHoc>
			);
		}
	}

	return NavigationContainer;
};

NavigationWithHoc.propTypes = {
	children: PropTypes.node.isRequired,
};

export default NavigationWithHoc;
